var h;(function(g){g.age="age",g.height="height",g.weight="weight",g.bust="bust"})(h||(h={}));export{h as ParameterType};
